<div
  class="calendar-event"
  [class.meeting-idd]="meeting.type?.key === MEETING_TYPE_IDD_TRAINING"
  [class.meeting-new-agent]="meeting.type?.key === MEETING_TYPE_NEW_AGENT_TRAINING"
  [class.meeting-ada]="meeting.type?.key === MEETING_TYPE_ADA"
  [class.meeting-training]="meeting.type?.key === MEETING_TYPE_TRAINING"
  [class.meeting-meeting]="meeting.type?.key === MEETING_TYPE_MEETING"
  [class.meeting-other]="meeting.type?.key === MEETING_TYPE_OTHER"
  (click)="handleEventClick()"
  [matTooltip]="tooltipText"
  matTooltipClass="break-line-tooltip"
  matTooltipPosition="above">
  <div fxLayout="column">
    <div fxLayout="row"  style="font-weight: bold; font-size: 16px">
      <ng-container >
        {{meeting.type.name}}
      </ng-container>
    </div>
    <div fxLayout="row"  style="font-weight: bold; font-size: 13px" >
       [{{meeting.startsAt | date:'HH:mm'}} - {{meeting.endsAt | date:'HH:mm'}}]

    </div>
    <div fxLayout="row">
      <ng-container *ngIf="meeting.type?.key !== MEETING_TYPE_IDD_TRAINING">
        <span fxFlex></span>
        <span class="bottom-right-text">
        {{meeting?.meetingLeading}}
           </span>
      </ng-container>
      <ng-container *ngIf="meeting.type?.key === MEETING_TYPE_IDD_TRAINING && meeting?.iddTrainingTrainer?.firstName && meeting?.iddTrainingTrainer?.lastName">
        <span fxFlex></span>
        <span class="bottom-right-text">
        {{meeting?.iddTrainingTrainer?.firstName + ' ' + meeting?.iddTrainingTrainer?.lastName }}
           </span>
      </ng-container>
    </div>

    <div fxLayout="row" *ngIf="meeting.address || meeting.insuranceCompany?.imageLocation || meeting.link || meeting.central || meeting.pge ">
      <ng-container *ngIf="meeting.insuranceCompany?.imageLocation">
        <img src="/rest/crm/insuranceCompany/{{meeting.insuranceCompany?.id}}/image" alt="Zdjęcie" height="20"/>
      </ng-container>
      <ng-container *ngIf="meeting.address && !meeting.central && !meeting.pge">
        <span fxFlex></span>
        <span class="bottom-right-text">
          <mat-icon>place</mat-icon> {{meeting.address.city}}
        </span>
      </ng-container>
      <ng-container *ngIf="meeting.central || meeting.pge">
        <span fxFlex></span>
        <span class="bottom-right-text">
          <mat-icon>meeting_room</mat-icon> {{meeting?.room?.name}}
        </span>
      </ng-container>
      <ng-container *ngIf="!meeting.address && !meeting.central && !meeting.pge">
        <span fxFlex></span>
        <span class="bottom-right-text">
          <mat-icon>language</mat-icon> {{meeting.place.name}}
        </span>
      </ng-container>
    </div>
  </div>
</div>

